import { Link } from "react-router-dom";
import { BellOff } from "lucide-react";
import { AppHeader } from "@/components/Layout";

export default function Unsubscribed() {
  return (
    <div className="min-h-screen bg-slate-50">
      <AppHeader />
      <div className="mx-auto max-w-lg px-5 py-20 text-center" data-testid="unsubscribed-page">
        <BellOff className="mx-auto h-10 w-10 text-slate-400" />
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-slate-900">SMS alerts stopped</h1>
        <p className="mt-3 text-slate-600">
          You will no longer receive food recall SMS alerts. Your account is still here if you change your mind.
        </p>
        <div className="mt-8 flex justify-center gap-3">
          <Link to="/settings#sms-alerts" data-testid="unsubscribed-settings-link" className="rounded-md bg-slate-900 px-5 py-3 text-sm font-semibold text-white">
            Turn alerts back on
          </Link>
          <Link to="/alerts" className="rounded-md border border-slate-300 px-5 py-3 text-sm font-medium text-slate-800">
            Browse recalls
          </Link>
        </div>
      </div>
    </div>
  );
}
